
export default {
    "company_header": "Detalles de la empresa",
    "header_product_warning": "¿Suscribiéndose al producto GrabCAD correcto? Suscribirse para {0}",
    "label": {
        "first_name": "Nombre",
        "last_name": "Apellido",
        "name": "Nombre",
        "company_name": "Nombre de la empresa",
        "university_name": "Nombre del colegio",
        "role": "Labor",
        "company_size": "Tamaño de la empresa",
        "phone_number": "Número de teléfono",
        "printer": "¿Tiene una impresora 3D?",
        "student_printer": "¿Tiene su colegio una impresora 3D?",
        "uses_printer_for": "¿Para qué utiliza su impresora 3D?",
        "shop_owner": "¿Es usted el responsable de administrar su tienda de modelos?",
        "shop_users_expected": "¿Cuántas personas envían pedidos a su tienda?",
        "email": "Correo electrónico",
        "email_confirm": "Confirme el correo electrónico",
        "email_again": "Vuelva a escribir el correo electrónico",
        "password": "Contraseña",
        "country": "Ubicación",
				"state": "Estado/Región",
        "password_confirm": "Confirme la contraseña",
        "password_again": "Vuelva a escribir la contraseña",
        "password_hint": "Mínimo de 6 caracteres",
        "interested_in": "Me interesa más...",
        "industry_vertical": "Industria vertical",
        "industry_level": "Nivel del puesto",
        "business_email": "Correo electrónico empresarial",
        "business_email_confirm": "Confirme el correo electrónico empresarial",
        "recaptcha": "Verifique que usted no es un robot",
        "industry_level_select": "Seleccionar Nivel del puesto",
        "company_size_select": "Seleccionar tamaño",
        "industry_vertical_select": "Seleccionar Industria vertical"
    },
    "placeholders": {
        "name": "P.ej. Jorge González",
        "first": "Primero",
        "last": "Último",
        "email": "Escriba el correo electrónico",
        "email_confirm": "Vuelva a escribir el correo electrónico",
        "password": "Escriba la contraseña",
        "company_name": "Escriba el nombre de la empresa",
        "university_name": "Escriba el nombre del colegio",
        "phone_number": "Escriba el número de teléfono",
        "printer": "Seleccione la respuesta",
        "country": "Seleccione el país",
				"state": "Seleccione su estado o región",
        "business_email": "Escriba el correo electrónico empresarial",
        "business_email_confirm": "Confirme el correo electrónico empresarial"
    },
    "terms": {
        "buy_now_text": "Al hacer clic en “Siguiente”, usted confirma que ha leído nuestros",
        "workbench_text": "Al hacer clic en “Suscribirse en Workbench”, usted confirma que ha leído nuestros",
        "print_text": "Al hacer clic en “Suscribirse”, usted confirma que ha leído nuestros",
        "text": "Al hacer clic en “Suscribirse en la Comunidad”, usted confirma que ha leído nuestros",
        "link": "Términos del servicio"
    },
	"software_terms": {
		"link": "Términos del software"
	},
    "privacy_policy": {
        "and": "y",
        "link": "Política de privacidad",
        "text": "y que acepta y está de acuerdo en ser regido por esos términos."
    },
    "actions": {
        "next": "Siguiente",
        "workbench_sign_up": "Suscribirse en Workbench",
        "sign_up_button": "Suscribirse",
        "shop_sign_up": "Suscríbase para una prueba de 30 días de la Tienda GrabCAD",
        "sign_up": "Suscribirse en la Comunidad",
        "cancel": "Cancelar"
    },
    "error": {
        "name_empty": "Agregue su nombre",
        "email_taken": "Este correo electrónico ya está registrado. Inicie sesión o elija otro correo electrónico.",
        "email_empty": "Agregue su correo electrónico",
        "email_nomatch": "Los correos electrónicos deben coincidir",
        "email_look": "Escriba un correo electrónico válido",
        "password_nomatch": "Las contraseñas deben coincidir",
        "password_short": "La contraseña es demasiado corta. Debe tener una longitud de 6 caracteres como mínimo.",
        "password_empty": "Escriba su contraseña",
        "recaptcha": "Haga clic en la casilla de verificación para comprobar que usted no es un robot",
        "country_blocked": "Lo sentimos, no puede registrarse en GrabCAD",
        "blank": "no puede estar en blanco"
    },
    "active": {
        "email": "Vuelva a escribir su verdadera dirección de correo electrónico, donde enviaremos el vínculo de confirmación de la cuenta."
    },
    "own_printer": {
        "default": {
            "no_dont_plan": "No, y no lo he planificado",
            "no_but_interesed": "No, pero me interesa",
            "yes_for_work": "Sí, por trabajo",
            "yes_as_hobby": "Sí, como un pasatiempo",
            "yes_for_other": "Sí, por otras razones"
        },
        "student": {
            "no_dont_plan": "No, mi colegio no está interesado en la impresión 3D",
            "no_but_interesed": "No, pero mi colegio está comprando una impresora 3D",
            "yes_they_do": "Sí",
            "not_sure": "No estoy seguro"
        }
    },
    "uses_printer_for": {
        "professional": "Uso profesional",
        "education": "Educación/Investigación",
        "hobby": "Pasatiempo",
        "dont_use": "No utilizo una Impresora 3D"
    },
    "level_values": {
        "administrator_principal_superintendent": "administrador",
        "biomedical_engineer": "ingeniero biomédico",
        "c_level_executive": "comité ejecutivo",
        "clinical_preclinical": "clínicos, pre-clínicos",
        "dean_department_head": "Decano / responsable de departamento",
        "dentist": "Dentista",
        "designer": "diseñador",
        "educator": "educador",
        "engineer": "Ingeniero",
        "equipment_manufacturer": "fabricante de equipos",
        "lab_owner": "responsable de  laboratorio",
        "lab_technician": "Técnico de laboratorio",
        "marketing": "Marketing",
        "medical_education_and_training": "educación y capacitación médica",
        "parent": "Familiar",
        "practicing_physician": "médico en ejercicio",
        "president_provost": "Presidente / rector",
        "prosthetist_orthotist": "protesistas y ortesistas",
        "purchasing": "Compras",
        "quality": "calidad",
        "rd_engineering": "i+D, Ingenieria",
        "sales": "Ventas",
        "senior_management_administration": "Alta Dirección / administración",
        "student": "Estudiante",
        "training": "formación",
        "other": "Otro",
        "not_employed": "No empleado"
    },
    "industry_values": {
        "aerospace": "Aeroespacial",
        "architecture": "Arquitectura",
        "arts_entertainment": "Artes y entretenimiento",
        "automotive": "Automotriz",
        "commercial_products": "Productos comerciales",
        "consumer_electronics": "Artículos electrónicos de consumo",
        "consumer_goods": "Bienes de consumo",
        "dental": "Servicio dental",
        "education": "Educación",
        "engineering_consulting_service": "Servicio de asesoramiento en ingeniería",
        "government_military": "Gobierno/Fuerzas Armadas",
        "industrial_equipment": "Equipos industriales",
        "jewelry": "Joyas",
        "medical_device": "Dispositivo o equipos médicos",
        "service_bureau": "Servicio informático",
        "toys": "Juguetes",
        "reseller": "Revendedor",
        "other": "Otro"
    },
    "company_size": {
        "0 - 100": "0 - 100",
        "100 - 500": "100 - 500",
        "500 - 1,000": "500 - 1000",
        "1,000 - 2,500": "1000 - 2500",
        "2,500 - 5,000": "2500 - 5000",
        "5,000 - 10,000": "5000 - 10000",
        "10,000 - 15,000": "10 000 - 15 000",
        "15,000 - 20,000": "15 000 - 20 000",
        "20,000+": "20 000+",
        "not_company": "No es una empresa"
    },
    "yes_no_values": {
        "yes": "Sí",
        "no": "No"
    }
}
